<div class="coupons-container container">
    <div class="coupons-header"></div>
    <div class="coupons-content"></div>
    <div class="coupons-bottom"></div>
</div>
